import React from 'react';
import Video from '../assets/demovideo.mp4';
import './Css/HomePage.css';

const HomePage = ({ onOpenPopup }) => {
    return (
        <div>
            <div className="intro-section">
                <video className="intro-video" autoPlay loop muted playsInline>
                    <source src={Video} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className="intro-text">
                    <h1>
                        Allow your customers to <span className="flicker-text"></span> your products in their own space in mixed reality.
                    </h1>
                    <div className="button-group">
                        <button className="intro-cta-button" onClick={onOpenPopup}>Get Started</button>
                     <button
    className="book-demo-button"  
    onClick={() => window.location.href = 'https://calendly.com/gmekv/30min'}
>
    Book a Demo
</button>
                    </div>
                    <p className="intro-subtext">Create mixed reality store for completely free, in <span className="underline">2 minutes</span></p>
                </div>
            </div>
        </div>
    );
};

export default HomePage;